import { __decorate, __metadata } from "tslib";
import { IdItemModel, Trim, Expose, ItemModelProp, EditorDefinition, CrudEndpoints, ItemModelDefinition, ModelId } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { HealthInsuranceRestraints } from "./health-insurance.restraints";
let HealthInsuranceItem = /*#__PURE__*/(() => {
  let HealthInsuranceItem = class HealthInsuranceItem extends IdItemModel {
    toString() {
      return "HealthInsurance " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], HealthInsuranceItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], HealthInsuranceItem.prototype, "updateDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], HealthInsuranceItem.prototype, "enabled", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), __metadata("design:type", String)], HealthInsuranceItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], HealthInsuranceItem.prototype, "alias", void 0);
  __decorate([Expose(), __metadata("design:type", String)], HealthInsuranceItem.prototype, "ik", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], HealthInsuranceItem.prototype, "isPrivate", void 0);
  HealthInsuranceItem = __decorate([EditorDefinition({}, {
    allowAllExposed: true,
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/health-insurances',
    public: '/health-insurances'
  }), ItemModelDefinition({
    texts: {}
  }), UseRestraints(HealthInsuranceRestraints), ModelId("HealthInsuranceItem") // autogenerated by generate-model-ids
  ], HealthInsuranceItem);
  return HealthInsuranceItem;
})();
export { HealthInsuranceItem };